import { render, staticRenderFns } from "./FooterComponentHe.vue?vue&type=template&id=59b95d67&scoped=true"
import script from "./FooterComponentHe.vue?vue&type=script&lang=ts"
export * from "./FooterComponentHe.vue?vue&type=script&lang=ts"
import style0 from "./FooterComponentHe.vue?vue&type=style&index=0&id=59b95d67&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59b95d67",
  null
  
)

export default component.exports